import { useEffect } from "react";
import BntAsistenteDock from "@/components/asistente/BntAsistenteDock";
import BntAsistenteLauncher from "@/components/asistente/BntAsistenteLauncher";
import BntAsistentePanel from "@/components/asistente/BntAsistentePanel";
import BntAsistenteUnreadTasksModal from "@/components/asistente/BntAsistenteUnreadTasksModal";
import { BntAsistenteProvider, useBntAsistenteOptional } from "@/modules/asistente/BntAsistenteContext";
import {
  BNT_MSG_FOCUS_MAIN,
  BNT_MSG_MINIMIZE,
  BNT_MSG_SET_TAB,
  isBntAsistenteMessage,
} from "@/modules/asistente/bntAsistenteMessaging";
import { isBntAsistenteFloatingUiEnabled } from "@/modules/asistente/bntAsistenteFeatureFlags";

function BntAsistentePopupBridge() {
  const ctx = useBntAsistenteOptional();

  useEffect(() => {
    if (!ctx) return undefined;
    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      const data = event.data;
      if (!isBntAsistenteMessage(data)) return;

      if (data.type === BNT_MSG_MINIMIZE) {
        ctx.minimizePanel();
        if (data.tab) ctx.setActiveTab(data.tab);
        return;
      }
      if (data.type === BNT_MSG_FOCUS_MAIN) {
        if (data.path) {
          const target = String(data.path);
          const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
          if (target !== current) {
            window.location.assign(target.startsWith("http") ? target : `${window.location.origin}${target}`);
          }
        }
        window.focus();
        return;
      }
      if (data.type === BNT_MSG_SET_TAB && data.tab) {
        ctx.setActiveTab(data.tab);
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [ctx]);

  return null;
}

/**
 * Panel lateral + barra de tareas integrada + botón flotante.
 */
export default function BntAsistenteShell() {
  const floatingUiEnabled = isBntAsistenteFloatingUiEnabled();

  return (
    <BntAsistenteProvider floatingUiEnabled={floatingUiEnabled}>
      <BntAsistentePopupBridge />
      <BntAsistenteUnreadTasksModal />
      <BntAsistentePanel />
      {floatingUiEnabled ? <BntAsistenteDock /> : null}
      {floatingUiEnabled ? <BntAsistenteLauncher /> : null}
    </BntAsistenteProvider>
  );
}
